module.exports = {
  firebaseStorageURL: {
    // array of filenames from a firebase storage directory
    filename: [],

    // array of download URLs from a firebase storage directory
    dl: []
  }
}



// WEBPACK FOOTER //
// ./src/defines/firebaseStorageURL.js